module.exports = __webpack_public_path__ + "assets/Icona_contorni_menu_laterale.894e533e.svg";